// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#fbp-body-table-div {\n    overflow: auto;\n    max-height: 340px;\n}\n#fbp-body-table-div::-webkit-scrollbar {\n  width: 3px;\n  background: #fff;\n}\n#fbp-body-table-div::-webkit-scrollbar-thumb {\n  background: #999;\n}\n#fbp-body-table-div .bb {\n  border-bottom: 1px solid #c5c5c5;\n}\n\n", ""]);
// Exports
module.exports = exports;
